$(function() {
  // Open the right tab with URL hash
  hash = window.location.hash;
  var $elements = $('a[href="' + hash + '"]');
  $elements.click();
});